/**
 * @generated SignedSource<<01f44261cad9aef59fcacd236ec168f3>>
 * @relayHash 1e79e599cf0986bfab52cda14838f58b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b204ce99dbc883bcc44bc4a88014083df60b82880ea056642e055bb80de3551e

import type { ConcreteRequest } from 'relay-runtime';
export type PageOwnershipByLineWithCollaboratorsDropdownContentQuery$variables = {
  cloudId: string;
  first: number;
  id: string;
  spaceKey: string;
};
export type PageOwnershipByLineWithCollaboratorsDropdownContentQuery$data = {
  readonly confluence_contentCollaborators: {
    readonly count: number | null;
    readonly nodes: ReadonlyArray<{
      readonly agent: {
        readonly accountId: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null;
      readonly person: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly jobTitle?: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      };
    } | null> | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly status: string | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly id: string | null;
  } | null;
};
export type PageOwnershipByLineWithCollaboratorsDropdownContentQuery = {
  response: PageOwnershipByLineWithCollaboratorsDropdownContentQuery$data;
  variables: PageOwnershipByLineWithCollaboratorsDropdownContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v4 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "args": [
    (v4/*: any*/),
    {
      "kind": "Literal",
      "name": "status",
      "value": [
        "current",
        "draft",
        "archived"
      ]
    }
  ],
  "concreteType": "PaginatedContentListWithChild",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "status"
        }
      ]
    }
  ]
},
v7 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "concreteType": "SpaceUserMetadata",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAdmin"
        }
      ]
    }
  ]
},
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v4/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "count"
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v12 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "jobTitle"
    }
  ],
  "type": "KnownUser"
},
v15 = {
  "concreteType": "ConfluenceAgent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v13/*: any*/),
    (v12/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
    "selections": [
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "args": (v8/*: any*/),
        "concreteType": "ConfluenceCollaboratorConnection",
        "kind": "LinkedField",
        "name": "confluence_contentCollaborators",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "concreteType": "ConfluenceCollaborator",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/)
                ]
              },
              (v15/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
    "selections": [
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "args": (v8/*: any*/),
        "concreteType": "ConfluenceCollaboratorConnection",
        "kind": "LinkedField",
        "name": "confluence_contentCollaborators",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "concreteType": "ConfluenceCollaborator",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/)
                ]
              },
              (v15/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1e79e599cf0986bfab52cda14838f58b",
    "id": "b204ce99dbc883bcc44bc4a88014083df60b82880ea056642e055bb80de3551e",
    "metadata": {},
    "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
    "operationKind": "query",
    "text": "query PageOwnershipByLineWithCollaboratorsDropdownContentQuery($cloudId:ID!,$id:ID!,$spaceKey:String!,$first:Int!){content(id:$id,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status}},space(key:$spaceKey){id,currentUser{isAdmin}},confluence_contentCollaborators(cloudId:$cloudId,id:$id,first:$first){count,nodes{person{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,jobTitle}},agent{displayName,accountId,profilePicture{path}}}}}"
  }
};
})();

(node as any).hash = "c82cea2a9b2b6126e7fc7b1f235c58f3";

export default node;
